// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from '../TEMPLATE'

export const Venmo = createSinglePathSVG({
  path: 'M14.447 1.529c.48 1.004.789 2.225.789 4.013 0 3.274-2.318 8.07-4.198 11.128L9.024.524.71 1.313 4.52 24h9.49c4.16-5.456 9.28-13.224 9.28-19.198 0-1.874-.394-3.36-1.269-4.802l-7.573 1.529h0',
  viewBox: '0 0 24 24',
  glyph: 'Venmo',
})
